import AirportService from '../api/airport-service'

export default {
    state: {
        airports: [],
        selectedAirportId: 0,
        selectedTerminalId: 0
    },
    mutations: {
        populateAirports (state, airports) {
            state.airports = airports
        },
        appendTerminalsToAirport (state, data) {
            state.airports.find(a => a.id === data.airportId).terminals = data.terminals
        },
        setSelectedAirportId (state, airportId) {
            state.selectedAirportId = airportId
        },
        setSelectedTerminalId (state, terminalId) {
            state.selectedTerminalId = terminalId
        },
        resetSelectedTerminalId (state) {
            state.selectedTerminalId = 0
        },
        resetSelectedAirportAndTerminal (state) {
            state.selectedAirportId = 0
            state.selectedTerminalId = 0
        }
    },
    actions: {
        async getAirports (context) {
            return AirportService.getAirports().then((response) => {
                context.commit('populateAirports', response.data)
                return response
            })
        },
        async setSelectedAirportId (context, airportId) {
            if (airportId !== 0) {
                const response = await AirportService.getTerminalsForAirport(airportId)
                context.commit('appendTerminalsToAirport', { airportId, terminals: response.data })
                if (response.data.length === 1) { context.commit('setSelectedTerminalId', response.data[0].id) } else { context.commit('resetSelectedTerminalId') }
            }
            context.commit('setSelectedAirportId', airportId)
        },
        async resetSelectedAirportAndTerminal (context) {
            context.commit('resetSelectedAirportAndTerminal')
        }
    },
    getters: {
        getSelectedAirport: state => {
            return state.airports.find(a => a.id === state.selectedAirportId)
        }
    }
}
